import {Component} from 'react';
import PropTypes from 'prop-types';
import {addTenantToPayload} from '../../utils';

class BaseSaveModal extends Component {
    constructor(props) {
        super(props);
        this._incrementStep = this._incrementStep.bind(this);
        this._decrementStep = this._decrementStep.bind(this);
        this._createNewLibrary = this._createNewLibrary.bind(this);
        this._findLibraryId = this._findLibraryId.bind(this);
        this._handleNameBlockNext = this._handleNameBlockNext.bind(this);
    }

    componentDidMount() {
        this.props.sendValidatedToParent(false);
    }

    componentWillUnmount() {
        this.props.sendValidatedToParent(true);
        if (typeof this.onComponentWillUnmount === 'function') {
            this.onComponentWillUnmount();
        }
    }

    _incrementStep () {
        this.setState((prevState) => ({ step: prevState.step + 1 }));
    }

    _decrementStep () {
        this.setState((prevState) => ({ step: prevState.step - 1 }));
    }

    _createNewLibrary (name) {
        const payload = {
            userId: this.props.userId,
            name,
            version: '1.0',
            dependentLibrary: []
        };

        addTenantToPayload(payload, this.props.tenantId, this.props.snapTenantGuid);
        this.props.saveLibrary(payload);
    }

    _findLibraryId (libraryName) {
        for (const library of this.props.libraries) {
            if (libraryName === library.name) {
                return library.id;
            }
        }

        return '';
    }

    _handleNameBlockNext (blockInfo) {
        this.setState({ blockInfo });

        const hasLibraryName = !!blockInfo.library;
        let hasExistingLibrary = false;
        for (const library of this.props.libraries) {
            if (blockInfo.library === library.name) {
                hasExistingLibrary = true;
                break;
            }
        }

        if (hasLibraryName && !hasExistingLibrary) {
            this._createNewLibrary(blockInfo.library);
        }

        this._incrementStep();
    }
}

BaseSaveModal.propTypes = {
    sendValidatedToParent: PropTypes.func,
    userId: PropTypes.string,
    tenantId: PropTypes.string,
    snapTenantGuid: PropTypes.string,
    saveLibrary: PropTypes.func,
    libraries: PropTypes.array
};

export default BaseSaveModal;